module.exports = "<div class=\"victories\" id=\"victories\"></div>\n";